import dompurify from 'dompurify'

export const optionFormat = (option: string) => {
  const div = document.createElement('div')
  div.innerHTML = dompurify.sanitize(option)
  const res = div.innerText
  div.remove()
  return res
}
